import { Stack, useTheme } from "@mui/material";
import React, { useEffect, useState } from "react";
import { USER_PERMISSIONS } from "@hyro/dashboard-permissions";
import { notifyToggleWidget } from "../../../analytics/notifyCustomActions";
import useAppStore from "../../../stores/appStore";
import {
  openWidgetInitiallySelector,
  previousSystemModeSelector, setHeaderSkeletonSelector,
  setIsWebSnippetOpenSelector,
  setSystemModeSelector,
  hasPermissionSelector,
  selectedAssistantSelector
} from "../../../stores/selectors/appSelectors";
import { StyledButton } from "../HeaderStyles";
import ShareIcon from "src/icons/ShareIcon";
import SharePreviewDialog from "../preview/SharePreviewDialog";
import { TOOLTIP_DELAY } from "@utils";
import { ASSISTANT_TYPES } from "@consts";
import Tooltip from "@hyro-components/Tooltip";
import { SHARE_PREVIEW_TOOLTIP_TITLE } from "@phrasing";
import { SYSTEM_MODES } from "src/stores/slices/createAppSlice";
import DevBanner from "src/layout/Header/header-types/dev-banner/DevBanner";

const PreviewModeHeader = () => {
  const selectedAssistant = useAppStore(selectedAssistantSelector);
  const setIsWebSnippetOpen = useAppStore(setIsWebSnippetOpenSelector);
  const setSystemMode = useAppStore(setSystemModeSelector);
  const previousSystemMode = useAppStore(previousSystemModeSelector);
  const setShowHeaderSkeleton = useAppStore(setHeaderSkeletonSelector);
  const openWidgetInitially = useAppStore(openWidgetInitiallySelector);
  const hasPermission = useAppStore(hasPermissionSelector);
  const [isSharePreviewDialogOpen, setIsSharePreviewDialogOpen] = useState(false);
  const theme = useTheme();
  const isShareable = selectedAssistant?.type === ASSISTANT_TYPES.LIVE || previousSystemMode === SYSTEM_MODES.EDIT;

  useEffect(() => {
    setShowHeaderSkeleton(false);

    if (openWidgetInitially) {
      notifyToggleWidget("Opened");
      setIsWebSnippetOpen(true);
    }

  }, []);

  const handleExitPreviewMode = () => {
    notifyToggleWidget("Closed");
    setSystemMode(previousSystemMode);
    setIsWebSnippetOpen(false);
  };

  return <Stack direction='row'>
    <Stack direction='row' sx={{ ml: "auto" }} alignItems={"center"} justifyContent='center' gap={1}>
      {hasPermission(USER_PERMISSIONS.SHARE_PREVIEW.READ) &&
        <Tooltip title={isShareable ? "" : SHARE_PREVIEW_TOOLTIP_TITLE} placement="bottom" tooltipStyle={{ maxWidth: "150px" }} enterDelay={TOOLTIP_DELAY.LONG} enterNextDelay={TOOLTIP_DELAY.LONG}>
          <StyledButton
            onClick={() => setIsSharePreviewDialogOpen(true)}
            disabled={!isShareable}
            sx={{ gap: "8px" }}
            variant="outlined">
            <ShareIcon stroke={isShareable ? theme.palette.primary[500] : theme.palette.grey[400]} /> Share
          </StyledButton>
        </Tooltip>}

      <StyledButton
        onClick={handleExitPreviewMode}
        variant="outlined">
        Exit
      </StyledButton>
    </Stack>
    <DevBanner />
    <SharePreviewDialog isSharePreviewDialogOpen={isSharePreviewDialogOpen} setIsSharePreviewDialogOpen={setIsSharePreviewDialogOpen} />
  </Stack>;
};

export default PreviewModeHeader;
